<template>
  <div class="deposit-info-overview-wrapper">
    <div class="deposit-info-overview">
      <div class="deposit-info-overview__row">
        <span class="deposit-info-overview__label">Gross Amount</span>
        <span class="deposit-info-overview__value">${{ formattedGrossAmount }}</span>
      </div>
      <div class="deposit-info-overview__row">
        <span class="deposit-info-overview__label">From</span>
        <span class="deposit-info-overview__value">{{ cardMasked }}</span>
      </div>

      <div class="deposit-info-overview__row">
        <span class="deposit-info-overview__label">Arrives</span>
        <span class="deposit-info-overview__value">{{ arrivesText }}</span>
      </div>

      <template v-if="hasFeeSplit">
        <div class="deposit-info-overview__row">
          <span class="deposit-info-overview__label deposit-info-overview__label--stacked">
            Processing Fee
            <span class="deposit-info-overview__sublabel"
              >On first ${{ formattedFirstAmountFree }}</span
            >
          </span>
          <span class="deposit-info-overview__value">Free</span>
        </div>
        <div v-if="overLimitAmount > 0" class="deposit-info-overview__row">
          <span class="deposit-info-overview__label deposit-info-overview__label--stacked">
            {{ overLimitFeeLabel }}
            <span class="deposit-info-overview__sublabel"
              >On ${{ formattedOverLimitAmount }} beyond promo limit</span
            >
          </span>
          <span v-if="Number(feeAmount) === 0" class="deposit-info-overview__value">Free</span>
          <span v-else class="deposit-info-overview__value"> -${{ formattedFeeAmount }} </span>
        </div>
      </template>
      <div v-else class="deposit-info-overview__row">
        <span class="deposit-info-overview__label">{{
          feePercent === 0 || Number(feeAmount) === 0
            ? 'Processing Fee'
            : `Processing Fee (${feePercent}%)`
        }}</span>
        <span v-if="Number(feeAmount) === 0" class="deposit-info-overview__value">Free</span>
        <span v-else class="deposit-info-overview__value"> -${{ formattedFeeAmount }} </span>
      </div>

      <div v-if="hasPromo" class="deposit-info-overview__row">
        <span class="deposit-info-overview__label">
          Promo code
          <span class="deposit-info-overview__promo-badge">{{ promoCode }}</span>
        </span>
        <span class="deposit-info-overview__value deposit-info-overview__value--promo"
          >+${{ formattedPromoBonus }}</span
        >
      </div>
      <div v-if="hasPromotionalCredit" class="deposit-info-overview__row">
        <span class="deposit-info-overview__label">Promotional Credit</span>
        <span class="deposit-info-overview__value">${{ formattedPromotionalCredit }}</span>
      </div>
      <div class="deposit-info-overview__divider"></div>

      <div class="deposit-info-overview__row deposit-info-overview__row--total">
        <span class="deposit-info-overview__label deposit-info-overview__label--total"
          >Total to wallet</span
        >
        <span class="deposit-info-overview__value deposit-info-overview__value--total"
          >${{ formattedTotalToWallet }}</span
        >
      </div>
    </div>

    <div v-if="hasSeparateCredit" class="deposit-info-overview__separate-credit">
      <span class="deposit-info-overview__separate-credit-label">
        Promo code <strong>{{ separateCreditCode }}</strong
        >:
      </span>
      <span>${{ formattedSeparateCredit }} was already credited to your wallet separately.</span>
    </div>

    <div v-if="wasFeeDiscountApplied && isFeeWaived" class="deposit-info-overview__info-line">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <circle cx="7" cy="7" r="7" fill="#2A8856" />
        <rect x="6.25" y="6" width="1.5" height="5" rx="0.75" fill="white" />
        <rect x="6.25" y="3" width="1.5" height="1.5" rx="0.75" fill="white" />
      </svg>
      <span>{{ feeDiscountMessage }}</span>
    </div>
  </div>
</template>

<script src="./deposit-info-overview.js"></script>
<style src="./deposit-info-overview.scss" lang="scss"></style>
